import type { Guide } from '../types';

/**
 * S-24.10-10 — powiadomienia imienne z makiety FTL, których brakowało (scenariusz e2e 28). Dane pokazowe
 * z `e2e/setup/seed-e2e.ts` (`g3Trade2410`): przy DEMO/2026/10/G32 zmiana pojazdu DEMO 001 (opiekun planisty
 * FTL z danych pokazowych) na inny, przy DEMO/2026/10/G31 zgłoszone ryzyko i skierowanie do Trade — wpisy
 * administratora, więc planista i Team Leader widzą je jako cudze. Nagrywarka tylko wybiera filtr.
 */
export const guide: Guide = {
  flagKey: 'namedNotifications',
  title: 'Powiadomienia imienne: opiekun pojazdu, Team Leader, przekazanie do Trade, wariant w TMS',
  whatItDoes:
    'Dzwonek i strona „Powiadomienia” mają nowe powiadomienia skierowane do konkretnej osoby. Opiekun pojazdu dowiaduje się, że zlecenie zdjęto z jego auta, odpięto albo przekazano do Trade. Team Leader dostaje zgłoszone ryzyko i każde skierowanie zlecenia do Trade i cofnięcie z Trade, z powodem. Kto przekazał zlecenie do Trade, dostaje wiadomość o akceptacji przewoźnika, sprzedaży i zwrocie do FTL, a autor wariantu — że zlecenie z prezlecenia jest już w TMS i wariant można obsadzić. Własne zmiany nie dają powiadomień.',
  audience: ['planista FTL (opiekun pojazdu)', 'Team Leader (planista główny)', 'Trade'],
  presentationItems: ['S-24.10-10'],
  steps: [
    {
      route: '/notifications',
      target: 'history-unread',
      title: 'Opiekun pojazdu: zlecenie zdjęte z Twojego auta',
      description:
        'Planista, który w menu wskazał „Jestem opiekunem FTL”, dostaje powiadomienie, gdy ktoś zmieni pojazd w zleceniu jego auta, odepnie auto albo przekaże takie zlecenie do Trade — z numerami aut i powodem.',
      action: 'Otwórz „Powiadomienia” i wybierz w „Rodzaj” „Zlecenie zdjęte z Twojego pojazdu”.',
      recorder: {
        account: 'ftl',
        actions: [{ kind: 'select', label: 'Rodzaj', option: 'Zlecenie zdjęte z Twojego pojazdu' }],
      },
    },
    {
      route: '/notifications',
      target: 'history-unread',
      title: 'Team Leader: ryzyko i przekazania do Trade',
      description:
        'Team Leader widzi zgłoszone ryzyko z powodem oraz każde skierowanie zlecenia z FTL do Trade i cofnięcie z Trade do FTL — także te, które zrobił ktoś inny.',
      action: 'Wybierz w „Rodzaj” „Zgłoszone ryzyko (Team Leader)” albo „Skierowane do Trade (Team Leader)”.',
      recorder: {
        account: 'master',
        actions: [{ kind: 'select', label: 'Rodzaj', option: 'Zgłoszone ryzyko (Team Leader)' }],
      },
    },
    {
      route: '/notifications',
      target: 'history-unread',
      title: 'Wszystkie „Twoje” jednym kliknięciem',
      description:
        '„Tylko moje” zawęża listę do powiadomień imiennych — także wtedy, gdy przekazane przez Ciebie zlecenie Trade sprzedał, zaakceptował przewoźnika albo zwrócił do FTL, i gdy zlecenie z Twoim wariantem pojawiło się w TMS.',
      action: 'Zaznacz „Tylko moje”.',
      recorder: { account: 'master', actions: [{ kind: 'check', label: 'Tylko moje' }] },
    },
  ],
};
